import { findKey } from 'lodash-es'
import { toRgb, isEmpty, defaultTo } from '../utils/bits'

export default function generateGradient(
  type,
  solid = {},
  grdnt = {},
  image = {}) {

  const realTmpl = findKey(TMPLS, (test) => test(type, solid, grdnt, image))
  const currTmpl = defaultTo(realTmpl, FALLBACK_TMPL)

  return currTmpl
    .replace(SOLID_COLOR_PLH, toRgb(solid.color))
    .replace(SOLID_OPACITY_PLH, solid.opacity)
    .replace(IMAGE_COLOR_PLH, toRgb(image.color))
    .replace(IMAGE_OPACITY_PLH, image.opacity)
    .replace(GRDNT_COLOR_1_PLH, toRgb(grdnt.color_1))
    .replace(GRDNT_COLOR_2_PLH, toRgb(grdnt.color_2))
    .replace(GRDNT_OPACITY_1_PLH, grdnt.opacity_1)
    .replace(GRDNT_OPACITY_2_PLH, grdnt.opacity_2)
    .replace(GRDNT_DIRECTION_PLH, grdnt.direction)
}

const RADIAL_DIR = 'center'

const SOLID_COLOR_PLH = ':solid_color:'
const SOLID_OPACITY_PLH = ':solid_opacity:'

const IMAGE_COLOR_PLH = ':image_color:'
const IMAGE_OPACITY_PLH = ':image_opacity:'

const GRDNT_COLOR_1_PLH = ':grdnt_color_1:'
const GRDNT_COLOR_2_PLH = ':grdnt_color_2:'
const GRDNT_OPACITY_1_PLH = ':grdnt_opacity_1:'
const GRDNT_OPACITY_2_PLH = ':grdnt_opacity_2:'

const GRDNT_DIRECTION_PLH = ':grdnt_direction:'

const WHITE_TMPL = '#ffffff'
const FALLBACK_TMPL = WHITE_TMPL
const SOLID_COLOR_TMPL = `rgba(${SOLID_COLOR_PLH}, ${SOLID_OPACITY_PLH})`
const IMAGE_COLOR_TMPL = `rgba(${IMAGE_COLOR_PLH}, ${IMAGE_OPACITY_PLH})`
const GRDNT_COLOR_TMPL = `rgba(${GRDNT_COLOR_1_PLH}, ${GRDNT_OPACITY_1_PLH})`
const GRDNT_LINEAR_TMPL = `linear-gradient(
                             ${GRDNT_DIRECTION_PLH},
                             rgba(${GRDNT_COLOR_1_PLH}, ${GRDNT_OPACITY_1_PLH}),
                             rgba(${GRDNT_COLOR_2_PLH}, ${GRDNT_OPACITY_2_PLH}))`
const GRDNT_RADIAL_TMPL = `radial-gradient(
                             center, circle cover,
                             rgba(${GRDNT_COLOR_1_PLH}, ${GRDNT_OPACITY_1_PLH}) 0%,
                             rgba(${GRDNT_COLOR_2_PLH}, ${GRDNT_OPACITY_2_PLH}) 100%)`

const TMPLS = {
  [WHITE_TMPL]: (type, solid, grdnt, image) => false
    || !type.isKnown
    || (type.isSolid && isEmpty(solid.color))
    || (type.isGrdnt && isEmpty(grdnt.color_1))
    || (type.isImage && isEmpty(image.color)),
  [SOLID_COLOR_TMPL]: (type, solid, _grdnt, _image) => true
    && type.isSolid
    && !isEmpty(solid.color),
  [IMAGE_COLOR_TMPL]: (type, _solid, _grdnt, image) => true
    && type.isImage
    && !isEmpty(image.color),
  [GRDNT_COLOR_TMPL]: (type, _solid, grdnt, _image) => true
    && type.isGrdnt
    && !isEmpty(grdnt.color_1)
    && isEmpty(grdnt.color_2),
  [GRDNT_LINEAR_TMPL]: (type, _solid, grdnt, _image) => true
    && type.isGrdnt
    && !isEmpty(grdnt.color_1)
    && !isEmpty(grdnt.color_2)
    && (grdnt.direction !== RADIAL_DIR),
  [GRDNT_RADIAL_TMPL]: (type, _solid, grdnt, _image) => true
    && type.isGrdnt
    && !isEmpty(grdnt.color_1)
    && !isEmpty(grdnt.color_2)
    && (grdnt.direction === RADIAL_DIR)
}
